import React from 'react';
import ERROR_OUTLINE from '@arrive/ui-icons/svg/ic_error_outline.svg'

import LandingPage from '../LandingPage/LandingPage';

import CommittedCapacityNoResultStyles from './CommittedCapacityNoResult.scss';

interface CommittedCapacityNoResultProps {
  content?: React.ReactNode;
  subtitle?: string;
}

export default function CommittedCapacityNoResult({ content = null, subtitle = 'Load recently updated' }: CommittedCapacityNoResultProps) {
  return (
    <LandingPage
      actionLinkTo="/find-loads"
      className={CommittedCapacityNoResultStyles.loadUpdatedContainer}
      content={content}
      icon={ERROR_OUTLINE}
      subTitle={subtitle}
    />
  );
}
